module.exports = __webpack_public_path__ + "static/media/gallery7.b4eb8750.jpg";